import React from 'react';
import * as Yup from 'yup';

import TextControl from 'src/components/forms/controls/text';
import EditForm, { EditFormProps } from 'src/components/forms/editForm';
import Field from 'src/components/forms/field';
import { EventInstance } from 'src/stores/models/event';

type CreatePrescriptionTaskDialogProps = {
  classes: EditFormProps['classes'];
  item: EventInstance | Record<string, never>;
  onCancel: EditFormProps['onCancel'];
  onSave: EditFormProps['onSave'];
};

const CREATE_PRESCRIPTION_TASK_VALIDATOR = Yup.object().shape({
  notes: Yup.string().nullable(),
});

const CreatePrescriptionTaskDialog = (props: CreatePrescriptionTaskDialogProps) => (
  <EditForm
    {...props}
    validationSchema={CREATE_PRESCRIPTION_TASK_VALIDATOR}
    testid="create-prescription-task-dialog"
  >
    <Field
      name="notes"
      component={TextControl}
      label="Notes for clinician (optional)"
      multiline
      onKeyDown={e => e.stopPropagation()}
      placeholder="Add any additional context or instructions for the clinician..."
    />
  </EditForm>
);

export default CreatePrescriptionTaskDialog;
